import {isAxiosError} from 'axios'
import {anotarError} from '@/lib/bitacora-sesion'
import {claveDeError} from '@/lib/errors'
import {estadoHttp, rutaDeLaLlamada} from '@/lib/red-errores-mutacion'

/** Anota en la bitácora del feedback una consulta fallida, sin el cuerpo; no avisa ni reporta. */
export function anotarLecturaFallida(error: unknown): void {
  if (!isAxiosError(error)) return
  const status = estadoHttp(error)
  anotarError({
    metodo: (error.config?.method ?? 'get').toUpperCase(),
    ruta: rutaDeLaLlamada(error),
    ...(status !== undefined ? {status} : {}),
    clave: claveDeError(error),
  })
}
